// @mui
import { Skeleton, Card, CardContent, Stack } from '@mui/material';

export default function SkeletonJobPostCard() {
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CardContent sx={{ height: 1 }}>
        <Stack justifyContent="space-between" sx={{ height: 1 }}>
        <Skeleton height={40} />
        <Skeleton height={40} />
        </Stack>
      </CardContent>
    </Card>
  );
};
